import React from 'react'
import { Outlet, Route, Routes } from 'react-router-dom'
import { PrivateRoute } from '../../../auth/PrivateRoute'
import { ROLE } from '../../../auth'
import CommissionRulesList from './components/CommissionRulesList/CommissionRulesList'

const CommissionRulesPage: React.FC = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route
        index
        element={
          <PrivateRoute roles={[ROLE.ROLE_ADMIN, ROLE.ROLE_MANAGER, ROLE.ROLE_MERCHANT_MANAGER]}>
            <CommissionRulesList />
          </PrivateRoute>
        }
      />
    </Route>
  </Routes>
)

export default CommissionRulesPage
